export default {
  'bindTo': 'this',
  'method': function(){
    alert('Emetti Fattura')
  },
}
